import store from '@/state/store'
const hasAccess = store.getters['identity/hasAccess']

export const general = [
  {
    key: 'sos',
    alertCode: [11],
    label: 'global.alert.sosButton',
    category: 'global.alert.type.general',
    scope: null,
  },
  {
    key: 'gps',
    alertCode: [1, 37],
    label: 'global.alert.gpsDisarmed',
    category: 'global.alert.type.general',
    scope: null,
  },
  {
    key: 'temperature',
    alertCode: [17, 18],
    label: 'global.alert.temperature',
    category: 'global.alert.type.general',
    scope: hasAccess(['z1b-itemp:read']),
  },
  {
    key: 'battery',
    alertCode: [2],
    label: 'notification.alert.deviceLowPower',
    category: 'global.alert.type.general',
    scope: null,
  },
  {
    key: 'signal',
    alertCode: [3],
    label: 'notification.alert.signal',
    category: 'global.alert.type.general',
    scope: null,
  },
  {
    key: 'vibration',
    alertCode: [10],
    label: 'global.alert.vibration',
    category: 'global.alert.type.general',
    scope: null,
  },
  {
    key: 'engine',
    alertCode: [12],
    label: 'notification.field.machineOn/Off',
    category: 'global.alert.type.general',
    scope: null,
  },
  {
    key: 'geofence',
    alertCode: [7],
    label: 'global.alert.geofence',
    category: 'global.alert.type.general',
    scope: null,
  },
  {
    key: 'fuel',
    alertCode: [13, 14],
    label: 'global.alert.fuel',
    category: 'global.alert.type.general',
    scope: hasAccess(['z1d-fuelultrasonic:read', 'z1e-itank:read']),
  },
  {
    key: 'pto',
    alertCode: [62, 63],
    label: 'global.alert.pto',
    category: 'global.alert.type.general',
    scope: hasAccess(['z1l-pto:read']),
  },
  {
    key: 'door1',
    alertCode: [4, 19],
    label: 'global.alert.door1',
    category: 'global.alert.type.general',
    scope: hasAccess(['z1f-idoor:read']),
  },
  {
    key: 'door2',
    alertCode: [5, 20],
    label: 'global.alert.door2',
    category: 'global.alert.type.general',
    scope: hasAccess(['z1f-idoor:read']),
  },
  {
    key: 'route',
    alertCode: [75],
    label: 'global.alert.missRoute',
    category: 'global.alert.type.general',
    scope: hasAccess(['d7a-default-md-route:read']),
  },
  {
    key: 'idle',
    alertCode: [15],
    label: 'global.alert.idleTime',
    category: 'global.alert.type.general',
    scope: hasAccess(['notif_idle_parking:read']),
  },
  {
    key: 'park',
    alertCode: [16],
    label: 'global.alert.parkTime',
    category: 'global.alert.type.general',
    scope: hasAccess(['notif_idle_parking:read']),
  },
  {
    key: 'cover',
    alertCode: [36],
    label: 'global.alert.coverRemoved',
    category: 'global.alert.type.general',
    scope: hasAccess(['notif_covered_remove:read']),
  },
  {
    key: 'refrigerator',
    alertCode: [21, 22],
    label: 'global.alert.refrigerator',
    category: 'global.alert.type.general',
    scope: hasAccess(['notif_refrigerator:read']),
  },
  {
    key: 'excessiveStop',
    alertCode: [104],
    label: 'global.alert.excessiveStopInsideGeofence',
    category: 'global.alert.type.general',
    scope: hasAccess(['e1f-web-excessivestopinsidegeofence:read']),
  },
  {
    key: 'crashDetection',
    alertCode: [94, 95],
    label: 'global.alert.crashDetection',
    category: 'global.alert.type.general',
    scope: hasAccess(['teltonika-device:read']),
  },
  {
    key: 'drivingTime',
    alertCode: [117],
    label: 'notification.alert.drivingTime',
    category: 'global.alert.type.general',
    scope: null,
  },
  {
    key: 'offlineVehicle',
    alertCode: [118],
    label: 'notification.alert.deviceOffline',
    category: 'global.alert.type.general',
    scope: null,
  },
  {
    key: 'gpsJammerDetected',
    alertCode: [93],
    label: 'notification.alert.gpsJammerDetected',
    category: 'global.alert.type.general',
    scope: hasAccess(['e1m-general-jammer-detection:read']),
  },
  {
    key: 'gsmJammerDetected',
    alertCode: [88],
    label: 'notification.alert.gsmJammerDetected',
    category: 'global.alert.type.general',
    scope: hasAccess(['e1m-general-jammer-detection:read']),
  },
  {
    key: 'storageUnavailable',
    alertCode: [123],
    label: 'notification.alert.storageUnavailable',
    category: 'global.alert.type.general',
    scope: hasAccess(['e1p-general-storage-unavailable:read']),
  },
  {
    key: 'cameraOff',
    alertCode: [126],
    label: 'notification.alert.cameraOff',
    category: 'global.alert.type.general',
    scope: hasAccess(['e1o-general-camera-offline:read']),
  },
]

export const driverBehavior = [
  {
    key: 'acceleration',
    alertCode: [24],
    label: 'global.alert.suddenAcceleration',
    category: 'global.alert.type.driverBehavior',
    scope: null,
  },
  {
    key: 'deceleration',
    alertCode: [23],
    label: 'global.alert.suddenDeceleration',
    category: 'global.alert.type.driverBehavior',
    scope: null,
  },
  {
    key: 'overspeed',
    alertCode: [8],
    label: 'global.alert.overspeed',
    category: 'global.alert.type.driverBehavior',
    scope: null,
  },
  {
    key: 'sharpturn',
    alertCode: [25],
    label: 'global.alert.sharpTurn',
    category: 'global.alert.type.driverBehavior',
    scope: null,
  },
]

export const dms = [
  {
    key: 'sleepy',
    alertCode: [53],
    label: 'notification.field.sleepy',
    category: 'global.alert.type.dms',
    scope: null,
  },
  {
    key: 'disturbance',
    alertCode: [52],
    label: 'notification.alert.disturbance',
    category: 'global.alert.type.dms',
    scope: null,
  },
  {
    key: 'smoking',
    alertCode: [54],
    label: 'global.alert.smoking',
    category: 'global.alert.type.dms',
    scope: null,
  },
  {
    key: 'calling',
    alertCode: [55],
    label: 'notification.field.calling',
    category: 'global.alert.type.dms',
    scope: null,
  },
  {
    key: 'eyesClosed',
    alertCode: [51],
    label: 'notification.field.eyesClosed',
    category: 'global.alert.type.dms',
    scope: null,
  },
  {
    key: 'outframe',
    alertCode: [56],
    label: 'notification.alert.outframe',
    category: 'global.alert.type.dms',
    scope: null,
  },
  {
    key: 'seatbelt',
    alertCode: [110],
    label: 'global.alert.seatbelt',
    category: 'global.alert.type.dms',
    scope: hasAccess(['seat_belt_alert:read']),
  },
  {
    key: 'fatigueDriving',
    alertCode: [50],
    label: 'global.alert.fatigueDriving',
    category: 'global.alert.type.dms',
    scope: hasAccess(['fatigue_driving_alert:read']),
  },
  {
    key: 'infraredBlocked',
    alertCode: [111],
    label: 'global.alert.infraredBlocked',
    category: 'global.alert.type.dms',
    scope: hasAccess(['infrared_blocked_alert:read']),
  },
  {
    key: 'cameraBlocked',
    alertCode: [112],
    label: 'notification.alert.cameraBlocked',
    category: 'global.alert.type.dms',
    scope: null,
  },
  {
    key: 'driverUnrecognized',
    alertCode: [150],
    label: 'notification.alert.driverUnrecognized',
    category: 'global.alert.type.dms',
    scope: hasAccess(['e1n-dms-driver-unrecognized:read']),
  },
  {
    key: 'driverIdentified',
    alertCode: [148],
    label: 'notification.alert.driverIdentified',
    category: 'global.alert.type.dms',
    scope: hasAccess(['e1n-dms-driver-unrecognized:read']),
  },
  {
    key: 'driverDetected',
    alertCode: [149],
    label: 'notification.alert.driverDetected',
    category: 'global.alert.type.dms',
    scope: hasAccess(['e1n-dms-driver-unrecognized:read']),
  },
  {
    key: 'driverChanged',
    alertCode: [152],
    label: 'notification.alert.driverChanged',
    category: 'global.alert.type.dms',
    scope: hasAccess(['e1n-dms-driver-unrecognized:read']),
  },
]

export const adas = [
  {
    key: 'forwardCollision',
    alertCode: [90],
    label: 'global.alert.forwardCollison',
    category: 'global.alert.type.adas',
    scope: null,
  },
  {
    key: 'laneDeparture',
    alertCode: [92],
    label: 'global.alert.laneDeparture',
    category: 'global.alert.type.adas',
    scope: null,
  },
  {
    key: 'headwayMonitor',
    alertCode: [91],
    label: 'global.alert.headwayMonitor',
    category: 'global.alert.type.adas',
    scope: null,
  },
  {
    key: 'accidentIndication',
    alertCode: [96],
    label: 'global.alert.accidentIndication',
    category: 'global.alert.type.adas',
    scope: null,
  },
  {
    key: 'frontObjectDetected',
    alertCode: [113],
    label: 'global.alert.frontObjectDetected',
    category: 'global.alert.type.adas',
    scope: hasAccess(['front_object_detected_alert:read']),
  },
  {
    key: 'humanDetection',
    alertCode: [134],
    label: 'global.alert.humanDetection',
    category: 'global.alert.type.adas',
    scope: null,
  },
]

export const cdm = [
  {
    key: 'motionDetected',
    alertCode: [122],
    label: 'global.alert.motionDetected',
    category: 'global.alert.type.cdm',
    scope: hasAccess(['e1q-brinks-cdm:read']),
  },
  {
    key: 'movement',
    alertCode: [127],
    label: 'global.alert.movement',
    category: 'global.alert.type.cdm',
    scope: hasAccess(['e1q-brinks-cdm:read']),
  },
  {
    key: 'buzzerFaulty',
    alertCode: [128],
    label: 'global.alert.buzzerFaulty',
    category: 'global.alert.type.cdm',
    scope: hasAccess(['e1q-brinks-cdm:read']),
  },
  {
    key: 'motionFaulty',
    alertCode: [129],
    label: 'global.alert.motionFaulty',
    category: 'global.alert.type.cdm',
    scope: hasAccess(['e1q-brinks-cdm:read']),
  },
]

export const fleetTask = [
  {
    key: 'temperatureDelivery',
    alertCode: [151],
    label: 'global.alert.temperatureDelivery',
    category: 'global.alert.type.fleetTask',
    scope: hasAccess(['tms-cold-chain:read']),
  },
]

dms.push({
  key: 'crash',
  alertCode: [49],
  label: 'global.alert.crash',
  category: 'global.alert.type.dms',
  scope: null,
})

export const notifications = [...general, ...driverBehavior, ...dms, ...adas, ...cdm, ...fleetTask]

export const alertCategory = [
  {
    id: 'global.alert.type.adas',
    name: 'global.alert.type.adas',
    scope: hasAccess(['e1g-web-adas:read']),
  },
  {
    id: 'global.alert.type.dms',
    name: 'global.alert.type.dms',
    scope: hasAccess(['e1c-web-dms:read']),
  },
  {
    id: 'global.alert.type.general',
    name: 'global.alert.type.general',
    scope: true,
  },
  {
    id: 'global.alert.type.cdm',
    name: 'global.alert.type.cdm',
    scope: hasAccess(['e1q-brinks-cdm:read']),
  },
  {
    id: 'global.alert.type.driverBehavior',
    name: 'global.alert.type.driverBehavior',
    scope: true,
  },
  {
    id: 'global.alert.type.fleetTask',
    name: 'global.alert.type.fleetTask',
    scope: hasAccess(['fleet-task-instant:read']),
  },
]
